/**
 * 料金プランスワイパー機能の初期化
 * SPサイズ（768px未満）でのみSwiperを有効化
 */
const pricePlansSwiper = () => {
  const swiperElement = document.querySelector('.js-swiper-price-plans');
  if (!swiperElement) return;

  const breakpoint = 768;
  let swiper = null;
  const wrapperElement = swiperElement.querySelector('.swiper-wrapper');
  const slideElements = swiperElement.querySelectorAll('.swiper-slide');

  // PC時にSwiperのスタイルをリセットする関数
  const resetSwiperStyles = () => {
    if (!wrapperElement) return;

    // wrapperのインラインスタイルをリセット
    wrapperElement.style.transform = '';
    wrapperElement.style.transitionDuration = '';

    // slideのインラインスタイルをリセット
    slideElements.forEach((slide) => {
      slide.style.width = '';
      slide.style.marginRight = '';
    });
  };

  // Swiperを初期化する関数
  const initSwiper = () => {
    if (swiper) return;

    swiper = new Swiper('.js-swiper-price-plans', {
      slidesPerView: 1,
      spaceBetween: '2%',
      loop: true,
      speed: 500,
      navigation: {
        nextEl: '.swiper-button-next.swiper-button-next--price-plans',
        prevEl: '.swiper-button-prev.swiper-button-prev--price-plans',
      },
    });
  };

  // Swiperを破棄する関数
  const destroySwiper = () => {
    if (!swiper) return;

    swiper.destroy(true, true);
    swiper = null;
    // 破棄後にスタイルをリセット
    resetSwiperStyles();
  };

  // Swiperの有効/無効を切り替える関数
  const toggleSwiper = () => {
    if (window.innerWidth >= breakpoint) {
      // PCサイズ：Swiperを破棄してスタイルをリセット
      destroySwiper();
    } else {
      // SPサイズ：Swiperを初期化
      if (!swiper) {
        initSwiper();
      }
    }
  };

  // 初期化時にサイズに応じてSwiperを設定
  toggleSwiper();

  // リサイズ時に有効/無効を切り替え
  window.addEventListener('resize', toggleSwiper);
};

export { pricePlansSwiper };
